// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#menu {
  display: none;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  height: 80px;
  z-index: 99;
  border-bottom: 2px solid black;
}
#menu .navbar-toggler {
  color: white;
}
#menu li.active a {
  font-weight: bold;
}
#menu a[active=true] {
  font-weight: bold;
}
#menu i {
  font-size: 60px;
}
#menu a {
  cursor: pointer;
  color: #ffffff;
}
#menu li {
  padding-right: 70px;
}
#menu img {
  position: absolute;
  left: 15px;
  top: -2px;
}
@media screen and (max-width: 1200px) {
  #menu .navbar-collapse {
    background-color: #888888;
  }
  #menu #menu a {
    padding: 8px;
  }
}
@media screen and (max-width: 1366px) {
  #menu li {
    padding-top: 5px;
    padding-right: 85px !important;
  }
  #menu .logoholder {
    display: none !important;
  }
}
@media screen and (max-width: 1700px) {
  #menu li {
    padding-right: 40px !important;
    color: black;
  }
}

@media screen and (max-width: 575px) {
  #theNavbar {
    position: absolute;
    left: 0;
    width: 100vw;
    height: 80vh;
    overflow-y: scroll;
    background-color: #888888;
  }
}
.logoholder {
  display: inline-block;
  width: 100px;
  height: 80px;
  overflow: hidden;
}
.logoholder img {
  height: 70px;
  margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/menu/menu.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EAiBA,WAAA;EACA,8BAAA;AAfF;AADE;EACE,YAAA;AAGJ;AACI;EACE,iBAAA;AACN;AAIE;EACE,iBAAA;AAFJ;AAQE;EACE,eAAA;AANJ;AASE;EACE,eAAA;EACA,cAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,kBAAA;EAEA,UAAA;EAEA,SAAA;AAXJ;AAeE;EACE;IACE,yBAAA;EAbJ;EAiBI;IACE,YAAA;EAfN;AACF;AAmBE;EACE;IACE,gBAAA;IACA,8BAAA;EAjBJ;EAoBE;IACE,wBAAA;EAlBJ;AACF;AAqBE;EACE;IACE,8BAAA;IACA,YAAA;EAnBJ;AACF;;AAwBA;EACE;IACE,kBAAA;IACA,OAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,yBAAA;EArBF;AACF;AAyBA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAvBF;AAyBE;EACE,YAAA;EACA,eAAA;AAvBJ","sourcesContent":["#menu {\r\n  display: none;\r\n  background-color: rgba(0, 0, 0, .7);\r\n  color: white;\r\n  height: 80px;\r\n\r\n  .navbar-toggler {\r\n    color: white;\r\n  }\r\n\r\n  li.active {\r\n    a {\r\n      font-weight: bold;\r\n    }\r\n\r\n  }\r\n\r\n  a[active=\"true\"] {\r\n    font-weight: bold;\r\n  }\r\n\r\n  z-index: 99;\r\n  border-bottom: 2px solid black;\r\n\r\n  i {\r\n    font-size: 60px;\r\n  }\r\n\r\n  a {\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n  }\r\n\r\n  li {\r\n    padding-right: 70px;\r\n  }\r\n\r\n  img {\r\n    position: absolute;\r\n\r\n    left: 15px;\r\n\r\n    top: -2px;\r\n  }\r\n\r\n\r\n  @media screen and (max-width:1200px) {\r\n    .navbar-collapse {\r\n      background-color: #888888;\r\n    }\r\n\r\n    #menu {\r\n      a {\r\n        padding: 8px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1366px) {\r\n    li {\r\n      padding-top: 5px;\r\n      padding-right: 85px !important;\r\n    }\r\n\r\n    .logoholder {\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1700px) {\r\n    li {\r\n      padding-right: 40px !important;\r\n      color: black;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width:575px) {\r\n  #theNavbar {\r\n    position: absolute;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 80vh;\r\n    overflow-y: scroll;\r\n    background-color: #888888;\r\n  }\r\n}\r\n\r\n\r\n.logoholder {\r\n  display: inline-block;\r\n  width: 100px;\r\n  height: 80px;\r\n  overflow: hidden;\r\n\r\n  img {\r\n    height: 70px;\r\n    margin-top: 6px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
